import React, { useEffect } from 'react';
import Calendar from 'react-calendar';
import './Calendar.css';
import { useSelector, useDispatch } from 'react-redux';
import { pushSelectedDate, pushSelectedChipArray } from '../../slices/customQueryBodySlice';
import { formatDate } from '../../utils/utils';
export default function CalendarComponent() {
  let selectedDate = useSelector(state => state.customQueryBody.selectedDate);
  const queryStringArray = useSelector(state => state.customQueryBody.queryStringArray) || [];
  let calendarDate;
  useEffect(() => {
    calendarDate = selectedDate ? new Date(selectedDate) : new Date();
  }, [selectedDate]);
  /** Appending Tag Data */

  useEffect(() => {
    let chipArray = [];

    if (queryStringArray && queryStringArray.length > 0) {
      chipArray.push(queryStringArray.join(' '));
    }

    if (queryStringArray[2]) {
      dispatch(pushSelectedChipArray(chipArray));
    }
  }, [queryStringArray, dispatch]);
  const dispatch = useDispatch();

  const changeDate = e => {
    let formatted_date = formatDate(e);
    dispatch(pushSelectedDate(formatted_date));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Calendar, {
    value: calendarDate,
    maxDate: new Date(),
    onChange: changeDate,
    className: "rct-calendar",
    minDate: new Date('1991,01,01')
  }));
}